import { sgwtConnect } from '../../../api/connect';
import type { IHttpConfig } from '../httpClient.model';

export default (config: IHttpConfig): IHttpConfig => {
  const headers = {
    ...config.headers,
    Authorization: sgwtConnect.getAuthorizationHeader()!,
  };

  return {
    ...config,
    headers,
  };
};
